import { Config } from '../config/config';
import { CookieUtils } from './useCookie';

/** @deprecated */
enum FeatureFlag {
  ErsteLoader = 'ErsteLoader',
  EStreamStatsSimple = 'EStreamStatsSimple',
  EStreamStatsSimpleFilterBET = 'EStreamStatsSimpleFilterBET',
  EStreamStatsComplex = 'EStreamStatsComplex',
  CurrencyExchangeExplicitTDayBalance = 'CurrencyExchangeExplicitTDayBalance',
  CurrencyExchangeExchangeRateDegradation = 'CurrencyExchangeExchangeRateDegradation',
  CurrencyExchangeExchangeValidationMsg = 'CurrencyExchangeExchangeValidationMsg',
  AdvancedPortfolioGrid = 'AdvancedPortfolioGrid',
  OrderCurrencyExchange = 'OrderCurrencyExchange',
  PortfolioNewDesign = 'PortfolioNewDesign',
  CashAction = 'CashAction',
}

/** @deprecated */
const defaults: Record<FeatureFlag, string> = {
  [FeatureFlag.ErsteLoader]: 'false',
  [FeatureFlag.EStreamStatsSimple]: 'false',
  [FeatureFlag.EStreamStatsSimpleFilterBET]: 'false',
  [FeatureFlag.EStreamStatsComplex]: 'false',
  [FeatureFlag.CurrencyExchangeExplicitTDayBalance]: 'false',
  [FeatureFlag.CurrencyExchangeExchangeRateDegradation]: 'false',
  [FeatureFlag.CurrencyExchangeExchangeValidationMsg]: '',
  [FeatureFlag.AdvancedPortfolioGrid]: 'false',
  [FeatureFlag.OrderCurrencyExchange]: 'false',
  [FeatureFlag.PortfolioNewDesign]: 'false',
  [FeatureFlag.CashAction]: 'false',
};

/** @deprecated */
class FeatureFlagUtils {
  private getValue(flag: FeatureFlag): string | number | boolean {
    const res = CookieUtils.getCookie(flag);
    if (res === null) {
      return defaults[flag];
    }
    return res;
  }

  /** @deprecated */
  get isErsteLoader(): boolean {
    return this.getValue(FeatureFlag.ErsteLoader) === 'true';
  }

  /** @deprecated */
  set isErsteLoader(value: boolean) {
    CookieUtils.setCookie(FeatureFlag.ErsteLoader, value.toString());
  }

  /** @deprecated */
  get isEStreamStatsSimple(): boolean {
    return this.getValue(FeatureFlag.EStreamStatsSimple) === 'true';
  }

  /** @deprecated */
  set isEStreamStatsSimple(value: boolean) {
    CookieUtils.setCookie(FeatureFlag.EStreamStatsSimple, value.toString());
  }

  /** @deprecated */
  get isEStreamStatsComplex(): boolean {
    return this.getValue(FeatureFlag.EStreamStatsComplex) === 'true';
  }

  /** @deprecated */
  set isEStreamStatsComplex(value: boolean) {
    CookieUtils.setCookie(FeatureFlag.EStreamStatsComplex, value.toString());
  }

  /** @deprecated */
  get isCurrencyExchangeExplicitTDayBalance() {
    return this.getValue(FeatureFlag.CurrencyExchangeExplicitTDayBalance) === 'true';
  }

  /** @deprecated */
  set isCurrencyExchangeExplicitTDayBalance(value: boolean) {
    CookieUtils.setCookie(FeatureFlag.CurrencyExchangeExplicitTDayBalance, value.toString());
  }

  /** @deprecated */
  get isCurrencyExchangeExchangeRateDegradation() {
    return this.getValue(FeatureFlag.CurrencyExchangeExchangeRateDegradation) === 'true';
  }

  /** @deprecated */
  set isCurrencyExchangeExchangeRateDegradation(value: boolean) {
    CookieUtils.setCookie(FeatureFlag.CurrencyExchangeExchangeRateDegradation, value.toString());
  }

  /** @deprecated */
  get currencyExchangeExchangeValidationMsg() {
    return (this.getValue(FeatureFlag.CurrencyExchangeExchangeValidationMsg) || '') as string;
  }

  /** @deprecated */
  set currencyExchangeExchangeValidationMsg(value: string) {
    CookieUtils.setCookie(FeatureFlag.CurrencyExchangeExchangeValidationMsg, value);
  }

  /** @deprecated */
  get isOrderCurrencyExchangeEnabled() {
    return Config.FeatureFlags.isOrderCurrencyExchangeEnabled;
  }

  /** @deprecated */
  set isOrderCurrencyExchangeEnabled(value: boolean) {
    CookieUtils.setCookie(FeatureFlag.OrderCurrencyExchange, value.toString(), 30);
  }

  /** @deprecated */
  get isAdvancedPortfolioGrid(): boolean {
    return this.getValue(FeatureFlag.AdvancedPortfolioGrid) === 'true';
  }

  /** @deprecated */
  set isAdvancedPortfolioGrid(value: boolean) {
    CookieUtils.setCookie(FeatureFlag.AdvancedPortfolioGrid, value.toString(), 30);
  }

  /** @deprecated */
  get isPortfolioNewDesignEnabled() {
    return Config.FeatureFlags.isPortfolioNewDesignEnabled;
  }

  /** @deprecated */
  set isPortfolioNewDesignEnabled(value: boolean) {
    CookieUtils.setCookie(FeatureFlag.PortfolioNewDesign, value.toString(), 30);
  }
}

export const featureFlagUtils = new FeatureFlagUtils();
